import { useState, useCallback } from 'react';
import quarkusApi from '../../api/quarkusApi';

// Exclusão de compromisso pessoal em /personal-events/{id}.
export function useDeletePersonalEvent() {
  const [isDeleting, setDeleting] = useState(false);

  const remove = useCallback((personalEventId) => {
    setDeleting(true);
    return quarkusApi
      .delete(`/personal-events/${personalEventId}`, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .finally(() => setDeleting(false));
  }, []);

  return { remove, isDeleting };
}
